const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const _ = require("lodash");
const withVaultDispatch = require("../../core/hoc/withVaultDispatch");
const withAnimateScroll = require("../../core/hoc/withAnimateScroll");
const AT = require("../../core/vault/ActionTypes");
const OpsCart = require("../vault/OpsCart");
const Information = require("./Information");
const RadioItem = require("../RadioItem");
const Checkbox = require("../../core/view/Checkbox");

const CreditInfo = require("./CreditInfo");
const OrderSummary = require("./OrderSummary");
const ContactInfo = require("./ContactInfo");
const BookstoreUtil = require("../../../shared/BookstoreUtil");
const StoreUtil = require("../../../shared/StoreUtil");
const CopyTable = require("../data/CopyTable");
const OpsUser = require("../../core/vault/OpsUser");
const {
	addDevTestingShortcutHandler,
} = require("../../core/util/setupDevTestingShortcut");

const styles = require("./styles/BillingInfo.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultDispatch(Component);
	Component = withAnimateScroll(Component);
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "BillingInfo",

		propTypes: {
			cart: PT.object.isRequired,
			onContinue: PT.func,
			user: PT.object,

			// Injected by HOCs
			dispatch: PT.func.isRequired,
			animateScroll: PT.func.isRequired,
		},

		getValidation: function(props = this.props, state = this.state) {
			const validation = OpsCart.getGroupedStepValidation(
				props.cart,
				"billing"
			);

			if (state.shouldMovePhoneNumber) {
				delete validation.errorTypes.phone;
				validation.missing = validation.missing.filter(
					item => item !== "phone"
				);
				if (_.isEmpty(validation.errorTypes) && _.isEmpty(validation.missing)) {
					validation.isComplete = true;
				}
			}
			return validation;
		},

		getInitialState: function() {
			const {cart} = this.props;
			const billingInfo = OpsCart.getFormSection(cart, "billing");
			if (!billingInfo.name) {
				const accountInfo = OpsCart.getFormSection(cart, "account");
				const fullName = [accountInfo.firstName, accountInfo.lastName]
					.filter(Boolean)
					.join(" ");
				if (fullName) {
					billingInfo.name = fullName;
				}
			}
			this.alreadyScrolledToError = true;
			const hasSubscriptionItems = StoreUtil.hasSubscriptionItems(
				this.props.cart.items
			);

			const isUninitializedPlatformGuest =
				OpsUser.isPlatformGuest(this.props.user) &&
				!OpsUser.isInitialized(this.props.user);

			// if we don't have any subscription items, we need to collect the phone number
			// on this page since it won't have been collected on the account step.
			let shouldMovePhoneNumber = hasSubscriptionItems;

			// always override for unitialized users since the phone number won't
			// have been collected from the account page
			if (isUninitializedPlatformGuest) {
				shouldMovePhoneNumber = false;
			}

			return {
				agreeRecurring: false,
				showAgreeRecurringError: false,
				shouldMovePhoneNumber,
			};
		},

		componentDidMount: function() {
			this.teardown = addDevTestingShortcutHandler(() => {
				this.updateField("agreeRecurring", true);
			});
		},

		componentWillUnmount: function() {
			this.teardown();
		},

		componentDidUpdate: function(prevProps, prevState) {
			if (this.alreadyScrolledToError) return;
			const cart = this.props.cart;
			const copyShipping = OpsCart.shouldCopyShipping(cart);
			const validation = this.getValidation();
			const ef = _.keys(validation.errorTypes);
			const contactFields = _.keys(OpsCart.getFormSection(cart, "contact"));
			const billingFields = _.keys(OpsCart.getFormSection(cart, "billing"));
			const creditFields = _.keys(OpsCart.getFormSection(cart, "creditCard"));
			if (ef.length) {
				this.alreadyScrolledToError = true;
				if (_.intersection(ef, contactFields).length) {
					this.props.animateScroll({
						scrollThing: this.contactSection,
						timeRatio: 0.65,
						maxTime: 1000,
					});
				} else if (_.intersection(ef, creditFields).length) {
					this.props.animateScroll({
						scrollThing: this.creditSection,
						timeRatio: 0.65,
						maxTime: 1000,
					});
				} else if (_.includes(ef, "agreeRecurring") && this.acceptSection) {
					this.props.animateScroll({
						scrollThing: this.acceptSection,
						timeRatio: 0.65,
						maxTime: 1000,
					});
				} else if (_.intersection(ef, billingFields).length && !copyShipping) {
					this.props.animateScroll({
						scrollThing: this.billingSection,
						timeRatio: 0.65,
						maxTime: 1000,
					});
				}
			}
		},

		updateField: function(field, val) {
			let section = "billing";
			if (
				_.includes(
					["number", "cvv", "expMonth", "expYear", "agreeRecurring"],
					field
				)
			) {
				section = "creditCard";
			}
			this.props.dispatch({
				type: AT.UPDATE_CART_FORMDATA,
				section,
				vals: {[field]: val},
			});
		},

		onContinue: function() {
			const cart = this.props.cart;
			const validation = this.getValidation();
			if (validation.isComplete) {
				const canGoToNext = OpsCart.hasAlreadyPreparedOrder(cart);
				if (canGoToNext) {
					this.props.onContinue();
				} else {
					this.props.dispatch({type: AT.PREPARE_ORDER_REQUEST});
				}
			} else {
				this.alreadyScrolledToError = false;
				this.setState({showAgreeRecurringError: true});
				this.props.dispatch({type: AT.SHOW_ALL_CHECKOUT_VALIDATION});
			}
		},

		onSetCopyShipping: function(shouldCopy) {
			const cart = this.props.cart;
			if (shouldCopy === OpsCart.shouldCopyShipping(cart)) return;
			this.props.dispatch({
				type: AT.UPDATE_CART_SHOULD_COPY_SHIPPING,
				shouldCopy: shouldCopy,
			});
		},

		toggleAgree: function() {
			const ccInfo = OpsCart.getFormSection(this.props.cart, "creditCard");
			const agreed = ccInfo.agreeRecurring;
			this.setState({
				showAgreeRecurringError: false,
			});
			this.updateField("agreeRecurring", !agreed);
		},

		render: function() {
			const {cart} = this.props;
			let billingAddress = null;
			const billingInfo = OpsCart.getFormSection(cart, "billing");
			const contactInfo = OpsCart.getFormSection(cart, "contact");
			const isNewAccount = !OpsUser.isLoggedIn(this.props.user);

			// if the user is logged in, then we have an email we can use to pre-populate.
			if (!contactInfo.email && !isNewAccount) {
				const {user} = this.props;
				const email = OpsUser.getEmail(user);
				contactInfo.email = email;
			}

			const ccInfo = OpsCart.getFormSection(cart, "creditCard");

			const errorFields = this.getValidation();
			const showError = !_.isEmpty(errorFields.errorTypes);

			const copyShipping = OpsCart.shouldCopyShipping(cart);
			const needsShipping = OpsCart.needsShipping(cart);
			const needsRecurringBilling = OpsCart.needsRecurringBilling(cart);

			if (!copyShipping || !needsShipping) {
				billingAddress = (
					<Information
						values={billingInfo}
						initialTabIndex={13}
						updateField={this.updateField}
						errorFields={errorFields}
						className={styles.information}
						invalidAddressGroup={errorFields.invalidAddressGroup}
						addressType={"billing"}
					/>
				);
			} else {
				const lines = BookstoreUtil.formatAddressFromData(billingInfo);
				const inner = lines.map((line, i) => {
					return (
						<span key={"line" + i}>
							{line}
							<br />
						</span>
					);
				});
				billingAddress = <div className={styles.address}>{inner}</div>;
			}

			const createButton = (text, tabIndex, isSame) => {
				const isSelected = copyShipping === isSame;

				return (
					<RadioItem
						className={styles.radioItem}
						text={text}
						onClick={() => this.onSetCopyShipping(isSame)}
						isSelected={isSelected}
						tabIndex={tabIndex}
					/>
				);
			};

			let buttonsEl;
			if (needsShipping) {
				buttonsEl = (
					<div className={styles.buttons}>
						{createButton("Same as shipping", 10, true)}
						{createButton("Use different address", 11, false)}
					</div>
				);
			}

			let agreeEl;
			if (needsRecurringBilling) {
				const showAgreeError = _.includes(
					errorFields.missing,
					"agreeRecurring"
				);
				const agreeErrorText = showAgreeError
					? CopyTable.getFormErrorCopy()["E_MISSING"]
					: null;
				const subscriptionNumInfo = OpsCart.getNumSubscriptionsByType(
					cart.items
				);

				agreeEl = (
					<div className={styles.accept} ref={a => (this.acceptSection = a)}>
						<Checkbox
							className={styles.acceptCheck}
							text={CopyTable.getRecurringBillingCopy(subscriptionNumInfo)}
							onClick={this.toggleAgree}
							isErrored={showAgreeError}
							isSelected={ccInfo.agreeRecurring}
							tabIndex={9}
						/>
						<div className={styles.error}>{agreeErrorText}</div>
					</div>
				);
			}

			let showParts = ["phone", "email", "comments"];
			if (OpsCart.hasCodeItems(cart.items)) {
				showParts = ["phone", "your email"];
			}

			if (this.state.shouldMovePhoneNumber) {
				showParts = showParts.filter(item => item !== "phone");
			}

			return (
				<div className={styles.main}>
					{this.state.shouldMovePhoneNumber ? (
						<div className={styles.title} ref={c => (this.creditSection = c)}>
							{"Billing Information"}
						</div>
					) : (
						<div className={styles.title} ref={c => (this.contactSection = c)}>
							{"Contact Information"}
						</div>
					)}
					<div className={styles.across}>
						<div className={styles.formContainer}>
							{!this.state.shouldMovePhoneNumber && (
								<ContactInfo
									contactInfo={contactInfo}
									subscribeOnCheckout={this.props.cart.subscribeOnCheckout}
									errorFields={errorFields}
									initialTabIndex={1}
									showParts={showParts}
								/>
							)}
							{!this.state.shouldMovePhoneNumber && (
								<div
									className={styles.title}
									ref={c => (this.creditSection = c)}
								>
									{"Billing Information"}
								</div>
							)}
							<div>
								<CreditInfo
									values={OpsCart.getFormSection(cart, "creditCard")}
									initialTabIndex={5}
									updateField={this.updateField}
									errorFields={errorFields}
								/>
								{agreeEl}
								<div
									className={styles.subtitle}
									ref={c => (this.billingSection = c)}
								>
									Billing Address:
								</div>
								{buttonsEl}
								{billingAddress}
							</div>
						</div>
						<OrderSummary
							{...this.props}
							showItemize={true}
							onContinue={this.onContinue}
							showError={showError}
							buttonText="Review"
							paypalButtonText={"Switch to"}
							tabIndex={500}
						/>
					</div>
				</div>
			);
		},
	})
);
